import React, { useState, useEffect } from 'react';
import axios from '../../api/axios';
import './Shared.css';

const Scoli = () => {
  const [scoli, setScoli] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingScoala, setEditingScoala] = useState(null);
  const [formData, setFormData] = useState({
    nume: '',
    adresa: '',
    telefon: '',
    email: ''
  });

  useEffect(() => {
    loadScoli();
  }, []);

  const loadScoli = async () => {
    try {
      const response = await axios.get('/api/admin/institutii?tip=scoala');
      setScoli(response.data);
    } catch (error) {
      console.error('Eroare la încărcare școli:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingScoala) {
        await axios.put(`/api/admin/institutii/${editingScoala._id}`, {
          ...formData,
          tip: 'scoala'
        });
      } else {
        await axios.post('/api/admin/institutii', {
          ...formData,
          tip: 'scoala'
        });
      }
      loadScoli();
      closeModal();
    } catch (error) {
      console.error('Eroare la salvare școală:', error);
      alert('Eroare la salvare școală');
    }
  };

  const handleEdit = (scoala) => {
    setEditingScoala(scoala);
    setFormData({
      nume: scoala.nume,
      adresa: scoala.adresa || '',
      telefon: scoala.telefon || '',
      email: scoala.email || ''
    });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Sigur doriți să ștergeți această școală?')) {
      try {
        await axios.delete(`/api/admin/institutii/${id}`);
        loadScoli();
      } catch (error) {
        console.error('Eroare la ștergere școală:', error);
        alert('Eroare la ștergere școală');
      }
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setEditingScoala(null);
    setFormData({
      nume: '',
      adresa: '',
      telefon: '',
      email: ''
    });
  };

  if (loading) return <div>Se încarcă...</div>;

  return (
    <div>
      <div className="page-header">
        <div>
          <h1>Gestiune Școli</h1>
          <p>Gestionează școlile din sistem</p>
        </div>
        <button className="btn btn-primary" onClick={() => setShowModal(true)}>
          + Adaugă Școală
        </button>
      </div>

      <div className="cards-grid">
        {scoli.map((scoala) => (
          <div key={scoala._id} className="card">
            <div className="card-header">
              <h3>🏫 {scoala.nume}</h3>
            </div>
            <div className="card-body">
              <p><strong>ID:</strong> <code>{scoala._id}</code></p>
              {scoala.adresa && <p><strong>Adresa:</strong> {scoala.adresa}</p>}
              {scoala.telefon && <p><strong>Telefon:</strong> {scoala.telefon}</p>}
              {scoala.email && <p><strong>Email:</strong> {scoala.email}</p>}
              <p><strong>Status:</strong> {scoala.activa ? '✅ Activă' : '❌ Inactivă'}</p>
            </div>
            <div className="card-actions">
              <button className="btn btn-secondary btn-sm" onClick={() => handleEdit(scoala)}>
                Editează
              </button>
              <button className="btn btn-danger btn-sm" onClick={() => handleDelete(scoala._id)}>
                Șterge
              </button>
            </div>
          </div>
        ))}
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editingScoala ? 'Editează Școala' : 'Adaugă Școală Nouă'}</h2>
              <button className="modal-close" onClick={closeModal}>&times;</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Nume Școală *</label>
                <input
                  type="text"
                  value={formData.nume}
                  onChange={(e) => setFormData({ ...formData, nume: e.target.value })}
                  required
                  placeholder="ex: Școala Gimnazială Gheorghe Lazăr"
                />
              </div>
              <div className="form-group">
                <label>Adresă</label>
                <input
                  type="text"
                  value={formData.adresa}
                  onChange={(e) => setFormData({ ...formData, adresa: e.target.value })}
                  placeholder="ex: Str. Principales nr. 10"
                />
              </div>
              <div className="form-group">
                <label>Telefon</label>
                <input
                  type="tel"
                  value={formData.telefon}
                  onChange={(e) => setFormData({ ...formData, telefon: e.target.value })}
                  placeholder="ex: 0259123456"
                />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  placeholder="ex: contact@scoala.ro"
                />
              </div>
              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={closeModal}>
                  Anulează
                </button>
                <button type="submit" className="btn btn-primary">
                  {editingScoala ? 'Salvează' : 'Adaugă'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Scoli;
